import React, {Component} from 'react';

import AnimatedWrapper from '../core/animated-wrapper';
import shareService from '../../services/share';
import SmartAd from '../ads/smart-ad';

import HeaderSection from './header-section';
import NewslettersSection from './newsletters-section';
import ArticlesSection from './articles-section';
import DailyNewsSection from './daily-news-section';
import RecommendationsSection from './recommendations-section';
import OpenSourceSection from './open-source-section';
import CommunitySection from './community-section';
import TeamSection from './team-section';

import homeService from '../../services/home-page';

import './new-home.css';

class Home extends Component {
  constructor(props) {
    super(props);

    shareService.setupPage({
      title: "Enjoy the web development world",
      fullTitle: ""
    });  

    this.state = {};
  }

  componentDidMount() {
    homeService.getData()
      .then((homePageData) => {
        this.setState({
          // isLoading: false,
          ...homePageData,
        });
      })
      .catch((error) => {
        // this.setState({
        //   isLoading: false,
        //   isError: true
        // });
      });
  }  

  render() {
    const { 
      newslettersTypes,
      articlesSummaries,
      recommendedArticles,
      dailyNews,
      openSourceProjects,
      communities,
      teamMembers,
    } = this.state;

    return (
      <div className='full-page new-home-page'>
        <div className='sections-container new-home-container'>
          <HeaderSection />

          <ArticlesSection articles={ articlesSummaries } className='dark' />
          <NewslettersSection newslettersTypes={ newslettersTypes } />
          <DailyNewsSection dailyNews={ dailyNews } className='dark' />
          <RecommendationsSection recommendations={ recommendedArticles } className='' />
          <OpenSourceSection openSourceProjects={ openSourceProjects } className='dark' />
          <CommunitySection communities={ communities } className='' />
          <TeamSection teamMembers={ teamMembers } className='dark' /> 

          <div className='fake-background-remover'></div>         
        </div>
      </div>
    );
  }
}

const AnimatedHome = AnimatedWrapper(Home);
export default AnimatedHome;